import React from 'react';
import { useState } from 'react';
import MonacoEditor from '@monaco-editor/react';
import MarkdownPreview from '../../../../components/editor/MarkdownPreview';
import EditorToolbar from './EditorToolbar';
import { useEditorStore } from '../../../../store/editorStore';
import { EditorContent } from '../../../../types/editor';

interface EditorProps {
  initialContent?: EditorContent;
  onChange: (content: EditorContent) => void;
  placeholder?: string;
}

export default function Editor({ initialContent, onChange, placeholder }: EditorProps) {
  const [content, setContent] = useState<EditorContent>(initialContent || {
    text: '',
    html: '',
    data: null
  });
  const [showPreview, setShowPreview] = useState(true);
  const { isFullscreen } = useEditorStore();

  const handleEditorChange = (value: string | undefined) => {
    if (value !== undefined) {
      const newContent: EditorContent = {
        text: value,
        html: value, // You might want to add markdown to HTML conversion here
        data: null
      };
      setContent(newContent);
      onChange(newContent);
    }
  };

  return (
    <div className={`flex flex-col border rounded-lg overflow-hidden ${
      isFullscreen ? 'fixed inset-0 z-50 bg-white' : 'h-[600px]'
    }`}>
      <EditorToolbar 
        onPreviewToggle={() => setShowPreview(!showPreview)}
        showPreview={showPreview}
      />
      
      <div className="flex flex-1 overflow-hidden">
        <div className={`${showPreview ? 'w-1/2' : 'w-full'} border-r`}>
          <MonacoEditor
            height="500px"
            defaultLanguage="markdown"
            defaultValue={content.text}
            onChange={handleEditorChange}
            options={{
              minimap: { enabled: false },
              lineNumbers: 'on',
              wordWrap: 'on',
              automaticLayout: true,
              scrollBeyondLastLine: false,
              fontSize: 14,
              tabSize: 2,
            }}
          />
        </div>
        
        {showPreview && (
          <div className="w-1/2">
            <MarkdownPreview content={content.text} />
          </div>
        )}
      </div>
    </div>
  );
}